import { graphql, useStaticQuery } from "gatsby"
import { getImage } from "gatsby-plugin-image"
import React from "react"
import { Target } from "../../utils"
import Info from "../shared/about/Info"
import HeadingM from "../shared/HeadingM"

const query = graphql`
  query {
    room: file(relativePath: { eq: "sutea/building.jpg" }) {
      childImageSharp {
        gatsbyImageData(width: 500)
      }
    }
  }
`

const AboutInfo = () => {
  const data = useStaticQuery(query)
  const items = {
    name: "すてあ",
    ceo: "中村　佑也",
    openDate: "2022年4月1日",
    address: "〒360-0012\n埼玉県熊谷市上之１８７７−４",
    openingHours: "通常 (月〜金) 9:30〜18:30 \n長期休み、土曜日 (春・夏・冬休みなど) 9:00〜18:00",
    phone: "048-598-4075",
    target: "sutea" as Target,
    image: getImage(data.room),
    mapLink: "https://maps.app.goo.gl/XCQo1buac72fUzeW8",
  }
  return (
    <div>
      <HeadingM title="施設について" target="sutea" />
      <Info {...items} />
    </div>
  )
}

export default AboutInfo
